import React from "react";
import { Modal, Button, message } from "antd";
import './sendReminderModal.css';
import { useState } from "react";
import { CheckSquareOutlined, BorderOutlined, CheckSquareFilled, CheckOutlined } from "@ant-design/icons";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";


const SendReminderModal = ({ visible, onClose, onSend }) => {
  const [checked, setChecked] = useState(false);
  const [userDetails, _] = useRecoilState(userInfo);

  const handleClick = () => {
    setChecked(true);
    message.success("Thanks for your consent.");
  };
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      bodyStyle={{ padding: "16px" }}
      className="custom-send-reminder-modal"
    >
      {/* Email template preview */}
      <div
        style={{
          borderRadius: "8px",
          marginBottom: 20,
          maxHeight: "500px",
          overflowY: "auto",
        }}
      >

        <div style={{ fontSize: "12px", display: "flex", flexDirection: "column" }}>
          <span>
            Email will be sent From{" "}
          </span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <strong style={{ fontSize: "20px" }}>{userDetails.email}</strong>

            <Button
              size="small"
              style={{
                marginLeft: "12px",
                borderRadius: "6px",
                color: "green",
                border: "1px solid green",
                display: "flex",
                alignItems: "center",
                padding: "0 6px",
                fontSize: "10px",
                height: "22px",
                lineHeight: "20px",
              }}
              onClick={handleClick}
            >
              Accept <CheckOutlined style={{ color: "green" }} />
            </Button>
          </div>


        </div>

        <br />
        <p>Dear Team,</p><br />
        <p>
          We have partnered with Finkraft to help us claim maximum GST amount on our airline spends. It is very critical for us to have the invoice copies to claim GST as per the compliance requested by the Government.
        </p>
        <br />
        <p>
          We want to claim the GST amount on <strong>20th Sep 2025</strong>.
        </p>
        <br />
        <p>
          Can you please share all the requested invoices with Finkraft before <strong>10th Sep 2025</strong>.
        </p>
        <br />
        <p>Regards,<br />Team McKinsey</p>
      </div>

      {/* Footer buttons */}
      <div style={{ textAlign: "right" }}>
        <Button onClick={onClose} style={{ marginRight: 8 }}>
          Cancel
        </Button>
        <Button type="primary" onClick={onSend}>
          Send
        </Button>
      </div>
    </Modal>
  );
};

export default SendReminderModal;
